// 断开 重连倒计时

import { ws_url } from "@/http/url"
import { getToken, removeToken } from "@@/utils/cache/cookies"

let socket: WebSocket | null = null// 实例对象
let lockReconnect = false // 是否真正建立连接
let timeoutnum: NodeJS.Timeout | number | null = null // 超时链接
let time_headTime: NodeJS.Timeout | number | null = null // 心跳持续
let no_reconent = false // 彻底断开

const head_send_time = 10000// 心跳发送时间
const timeout_time = 5000 // ws重连时间

async function initWebSocket(wsUrl: string = ws_url) {
  if ("WebSocket" in window) {
    socket = new WebSocket(wsUrl)
    socket.onerror = webSocketOnError
    socket.onmessage = webSocketOnMessage
    socket.onclose = closeWebsocket
    socket.onopen = openWebsocket
    no_reconent = false
  } else {
    ElMessage.error("浏览器不支持webScoket")
  }
}

// 建立连接
function openWebsocket() {
  start()
}

// 开启心跳
function start() {
  // 这里发送一个心跳，后端收到后，返回一个心跳消息
  if (socket && socket.readyState === 1) {
    socket.send(JSON.stringify({ type: "login", token: getToken() }))
  } else {
    // 否则重连
    reconnect()
  }
}

// 重新连接
function reconnect() {
  if (lockReconnect) {
    return
  }
  lockReconnect = true
  // 没连接上会一直重连，设置延迟避免请求过多
  timeoutnum && clearTimeout(timeoutnum)
  time_headTime && clearTimeout(time_headTime)
  timeoutnum = null
  time_headTime = null
  timeoutnum = setTimeout(() => {
    if (socket) {
      socket.close()
      socket = null
    }
    // 新连接
    initWebSocket()
    lockReconnect = false
  }, timeout_time)
}

function webSocketOnError() {
  reconnect()
}

// 服务器返回的数据
function webSocketOnMessage(e: any) {
  const data = JSON.parse(e.data)
  if (data.type === "login") {
    socket && socket.send(JSON.stringify({ type: "heartbeat" }))
    if (time_headTime) return
    /** 定时发送心跳 */
    time_headTime = setInterval(() => {
      socket && socket.send(JSON.stringify({ type: "heartbeat" }))
    }, head_send_time)
  }
  window.dispatchEvent(new CustomEvent("onmessageWS", {
    detail: {
      data
    }
  }))
}

function closeWebsocket() {
  console.log("服务器主动断开", no_reconent)
  if (!no_reconent) {
    reconnect()
  } else if (socket) {
    close()
  }
}

// 断开连接
function close() {
  no_reconent = true
  timeoutnum && clearInterval(timeoutnum)
  time_headTime && clearInterval(time_headTime)
  timeoutnum = null
  time_headTime = null
  socket && socket.close()
  socket = null
  console.log("ws 断开连接")
}

// 断开连接
function to_page() {
  localStorage.clear()
  sessionStorage.clear()
  removeToken()
}
export { close, initWebSocket, socket, to_page, webSocketOnMessage }
